module.exports = __webpack_public_path__ + "static/media/codesandbox.56d5157f.svg";